var BindingsHelper = (function () {
    function BindingsHelper() {
        this.schemaObjectKeys = [
            'http.query',
            'kafka.groupId',
            'kafka.clientId',
            'kafka.key',
            'ws.headers',
            'ws.query',
        ];
    }
    BindingsHelper.prototype.isSchemaObject = function (context, bindingType) {
        return this.schemaObjectKeys.includes(bindingType + "." + context);
    };
    BindingsHelper.prototype.isObject = function (value) {
        return !!value && typeof value === 'object';
    };
    return BindingsHelper;
}());
export var bindingsHelper = new BindingsHelper();
//# sourceMappingURL=bindingsHelpers.js.map